// GENERATED FILE - DO NOT MODIFY
export enum WorkOrderMaintenanceType {
    Regular = "R",
    Pep = "P",
    Repair = "W",
}

export let nameof = "WorkOrderMaintenanceType";
